import { useRouter } from "next/router";
import React, { useEffect } from "react";

import { useAuth } from "@/custom-hooks/apis-common/use-auth";
import { isIncompletePath } from "@/utils/common-utils";

import { AUTH_FORGOT_PASS_PAGE, AUTH_INDEX_PATH, AUTH_SIGNUP_PATH, REPORT_INDEX_PATH } from "@/constants/app-path";
// import { authTokenInfoAtom, fbUserCredentialAtom, initializingAtom } from "@/global-states/common-atoms";
import { authTokenInfoAtom, initializingAtom } from "@/global-states/common-atoms";
import { useAtom } from "jotai";

type Props = {
  children: React.ReactNode;
};
const AuthProvider: React.FC<Props> = (props) => {
  const router = useRouter();
  // const { authSync, fbAuthSync } = useAuth();
  const { authSync } = useAuth();

  const [authTokenInfo] = useAtom(authTokenInfoAtom);
  const [initializing, setInitializing] = useAtom(initializingAtom);
  // const [fbUserCredential] = useAtom(fbUserCredentialAtom);

  useEffect(() => {
    if (!initializing) {
      return;
    }

    if (isIncompletePath(router.asPath)) {
      return;
    }

    (async () => {
      if (await authSync()) {
        if (
          !router.asPath ||
          router.asPath === "/" ||
          router.asPath === AUTH_INDEX_PATH ||
          router.asPath === AUTH_SIGNUP_PATH
        ) {
          await router.push(REPORT_INDEX_PATH);
        }
      } else if (![AUTH_FORGOT_PASS_PAGE, AUTH_SIGNUP_PATH].includes(router.asPath)) {
        // 認証失敗時は、ログイン画面へ
        await router.push(AUTH_INDEX_PATH);
      }
      setTimeout(() => setInitializing(false), 1);
    })();
  }, [initializing, router.asPath]);

  useEffect(() => {
    const timeout = setTimeout(() => authSync({ silent: true }), 1000 * 60 * 15);
    return () => clearTimeout(timeout);
  }, [authTokenInfo?.access_token]);

  return <>{props.children}</>;
};

export default AuthProvider;
